module.exports = __webpack_public_path__ + "img/logo2.98b1d79c.svg";